import Feature from 'ol/format/Feature';

export class FormatComponent {
  public instance: Feature;
  public componentType = 'format';
}
